module.exports = __webpack_public_path__ + "img/370.f3f01594.jpg";